export default "__VITE_ASSET__dc454129__"